// extracted by mini-css-extract-plugin
export default {"token":"Token_token__ZFkXC","tab":"Token_tab__bg9pu","content":"Token_content__lB+ES","contentContainer":"Token_contentContainer__kjUPE"};